import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title-3 text-grey-900 my-4 flex-1 flex-column d-flex"
}



  interface Props {
    title: string
    displayTitle?: boolean
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PageSection',
  props: {
    title: {},
    displayTitle: { type: Boolean, default: true }
  },
  setup(__props: any) {

  // Vue
  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.displayTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})